import { ReactNode } from "react";
import { LuDatabase } from "react-icons/lu";
import { card } from "../../../app-components/ui/styles";

type DashCardProps = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** shows the "waiting for data" state instead of children */
  empty?: boolean;
  emptyNote?: string;
  bodyClassName?: string;
};

export const WaitingForData = ({ note }: { note?: string }) => (
  <div className="flex h-full min-h-[180px] flex-col items-center justify-center px-6 py-8 text-center">
    <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-hcBg text-hcMuted">
      <LuDatabase className="h-5 w-5" aria-hidden />
    </div>
    <p className="text-sm font-medium text-honeConnectBlack">Waiting for data</p>
    <p className="mt-1 max-w-xs text-xs leading-relaxed text-hcMuted">
      {note ?? "This chart will fill in once the dashboard API sends it."}
    </p>
  </div>
);

const DashCard = ({
  title,
  subtitle,
  action,
  children,
  className = "",
  empty,
  emptyNote,
  bodyClassName = "px-5 pb-5",
}: DashCardProps) => (
  <section className={`${card} flex min-w-0 flex-col ${className}`}>
    <header className="flex flex-wrap items-start justify-between gap-3 px-5 pb-4 pt-5">
      <div className="min-w-0">
        <h2 className="text-[15px] font-semibold text-honeConnectBlack">{title}</h2>
        {subtitle && <p className="mt-0.5 text-xs text-hcMuted">{subtitle}</p>}
      </div>
      {action && !empty && <div className="flex items-center gap-2">{action}</div>}
    </header>
    <div className={`min-w-0 flex-1 ${bodyClassName}`}>
      {empty ? <WaitingForData note={emptyNote} /> : children}
    </div>
  </section>
);

export default DashCard;
